

  <!-- <app-project-control></app-project-control> -->
  <app-tabs (footerStateChange)="onTabsStateChange($event)"></app-tabs>
  <!--<app-navaids></app-navaids>-->
  <!--<app-procedures></app-procedures>-->
  <!--<app-airspace-boundaries></app-airspace-boundaries>-->
  <!--<app-generic-window></app-generic-window>-->
  <!--<app-coordinate-points></app-coordinate-points>-->
  <!-- <app-calculation-procedures></app-calculation-procedures> -->
  <!--<app-create-navaid-from-map></app-create-navaid-from-map>-->
  <!--<app-procedure-navaid-association></app-procedure-navaid-association>-->
  <!--<app-fom-check></app-fom-check>-->
  <!--<app-navaids-filter></app-navaids-filter>-->
  <!--<app-procedures-filter></app-procedures-filter>-->
  <!-- <app-airspace-boundaries-filter></app-airspace-boundaries-filter> -->
  <!-- <app-coordinate-points-filter></app-coordinate-points-filter> -->
  <!--<app-altitude-filter></app-altitude-filter>-->
  <!-- <app-terrain-grid></app-terrain-grid> -->
  <!-- <app-azimuth-tool></app-azimuth-tool> -->
  <!-- <app-procedure-assessments></app-procedure-assessments> -->
  <!-- <app-horizon-tool></app-horizon-tool> -->
  <!-- <app-map-search></app-map-search> -->
  <!-- <app-multipath-tool></app-multipath-tool> -->
  <!-- <app-barometric-calculation></app-barometric-calculation> -->
  <!-- <app-coverage-quantitative-assessment-result></app-coverage-quantitative-assessment-result> -->
 <!--  <app-range-ring-tool></app-range-ring-tool> -->
  <!-- <app-performance-report></app-performance-report> -->
  <!-- <app-trajetcory></app-trajetcory> -->
  <!-- <app-trajetcory-filter></app-trajetcory-filter> -->
  <!-- <app-navaids-co-channels></app-navaids-co-channels> -->
  <!-- <app-saam-traffic-filter></app-saam-traffic-filter> -->
  <!-- <app-cross-section></app-cross-section> -->
